import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { updateSeekerProfileData } from '../../API/api';
import { toast } from 'react-toastify';
import { createTheme } from '@mui/material/styles';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Typography } from "@mui/material";
import { CURRENT_ROLE } from '../../API/url';
import SwitchComp from '../../NewComponent/Switch/Switch';



export default function ExpertPermissionsToggle({ firstName, setFirstName, lastName }) {
  const userState = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { storeUserData } = bindActionCreators(Actions, dispatch);
  const textValue = [{ text: "When an Expert answers your question", bool: userState.expertAnswered, value: 'expertAnswered' }, { text: "A new question has been shared with you", bool: userState.questionShared, value: 'questionShared' }];
  const expertTextValue = [{ text: "A new question is routed to you", bool: userState.newQuestion, value: 'newQuestion' },
  { text: "Your answer has been rated", bool: userState.seekerRated, value: "seekerRated" },
  { text: "A new question has been shared with you", bool: userState.questionShared, value: "questionShared" },
  { text: "Another expert answered one of your questions", bool: userState.anotherExpertAnswered, value: "anotherExpertAnswered" },
  { text: "New Express question is routed to you", bool: userState.newExpQuestion, value: "newExpQuestion" },
  ]
  const theme = createTheme({
    typography: {
      fontSize:12.5,
      fontFamily: [
        'inherit',
      ].join(','),
    },
    components:{
      MuiSwitch:{
        styleOverrides:{
          switchBase: {
            color: "#ccc",
            transition: '0.3s ease-in',
          },
          colorPrimary: {
            "&.Mui-checked": {
              color: "var(--light_color_shade)"
            }
          },
          track: {
            opacity: 0.2,
            backgroundColor: "grey",
            ".Mui-checked.Mui-checked + &": {
              opacity: 0.6,
              backgroundColor: "var(--light_color_shade)"
            }
          }
        }
      }
    }
  });
const toggleButtonToast = () => {
  return (
    <>
      <span style={{ fontSize: "12px" }}>
        Profile has been updated.
      </span>
    </>
  );
};
const ToggleItem = ({ discription, id }) => {
  const [toggleThisElement, setToggleThisElement] = useState(discription.bool === 1 ? true : false);
  const weeklyDigest = sessionStorage.getItem('weeklyDigest');
  const getWeeklyDigestValue = JSON.parse(weeklyDigest) || 0;
  const handleToggle = (e) => {
    setToggleThisElement(e.checked);
    const payloadData = {
      confirmPassword: "",
      currentPassword: "",
      expertAnswered: discription.value === 'expertAnswered' ? e === true ? 1 : -1 : userState.expertAnswered,
      firstName: firstName === '' ? userState.firstName : firstName,
      lastName: lastName === '' ? userState.lastName : lastName,
      newPassword: "",
      outOfOffice: userState.outOfOffice,
      questionShared: discription.value === 'questionShared' ? e === true ? 1 : -1 : userState.questionShared,
      anotherExpertAnswered: discription.value === 'anotherExpertAnswered' ? e === true ? 1 : -1 : userState.anotherExpertAnswered,
      newExpQuestion: discription.value === 'newExpQuestion' ? e === true ? 1 : -1 : userState.newExpQuestion,
      seekerRated: discription.value === 'seekerRated' ? e === true ? 1 : -1 : userState.seekerRated,
      newQuestion:discription.value === 'newQuestion' ? e === true ? 1 : -1 : userState.newQuestion,
      weeklyDigest:getWeeklyDigestValue
    }
    updateSeekerProfileData(payloadData).then((res) => {
      if (res===undefined) return;
      if (res.data.data !== '' && res.data.success) {
        userState.newQuestion = discription.value === 'newQuestion' ? e === true ? 1 : -1 : userState.newQuestion;
        userState.expertAnswered = discription.value === 'expertAnswered' ? e === true ? 1 : -1 : userState.expertAnswered;
        userState.questionShared = discription.value === 'questionShared' ? e === true ? 1 : -1 : userState.questionShared;
        userState.anotherExpertAnswered = discription.value === 'anotherExpertAnswered' ? e === true ? 1 : -1 : userState.anotherExpertAnswered;
        userState.newExpQuestion = discription.value === 'newExpQuestion' ? e === true ? 1 : -1 : userState.newExpQuestion;
        userState.seekerRated = discription.value === 'seekerRated' ? e === true ? 1 : -1 : userState.seekerRated;
        let newObj = {...userState}
        storeUserData(newObj);
        toast.success(toggleButtonToast(), {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      else {

      }
    })
  }
  return (
    <>
      {/* <Form.Group style={{ display: "flex" }}>
                    <Form.Label className="col-sm-6 labelName">
                        {discription && <p>{discription.text}</p>}
                    </Form.Label>
                    <div className="col-sm-6 text-end">
                        <label className="switch" key={id}>
                            <input
                                type="checkbox"
                                onChange={(e) => handleToggle(e)}
                                checked={toggleThisElement}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </Form.Group> */}
    {/* <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12" style={{display:'flex',justifyContent:'space-between',paddingTop:'12px'}}>
      <ThemeProvider theme={theme}>
        <FormGroup>
          <FormControlLabel sx={{fontSize: "14px" }} control={<Typography component="div">
            <SwitchComp  onChangeFunc={handleToggle} val={toggleThisElement} /></Typography>} label={discription.text} labelPlacement="start" />
        </FormGroup>
      </ThemeProvider>
      </div> */}
          <div className="col-lg-6 col-xl-6 col-md-6 col-sm-12 col-xs-12" style={{display:'flex',justifyContent:'space-between',paddingTop:'12px'}}>
            <div>{discription.text}</div>
            <div><SwitchComp onChangeFunc={handleToggle} val={toggleThisElement} /></div>
        </div>
    </>
  );
};

return (
  <>
    <div>
      <div className="row">
        <Form style={{cursor:"default"}}>
          {/* {CURRENT_ROLE === 'Seeker' && textValue.map((str, ind) => {
              return <ToggleItem discription={str} id={ind} />
            })} */}
        <div style={{display:'flex'}} className="row"> 
          {
            expertTextValue.map((str, ind) => {
              return <ToggleItem discription={str} id={ind} />
            })
          }
          </div>
        </Form>
      </div>
    </div>
  </>
)
}